import * as appkitPolyfills from '@reown/appkit-polyfills';
(window as any).__appkitPolyfills = appkitPolyfills; // no tree-shaking

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import { provideHttpClient, HttpBackend } from '@angular/common/http';
import { provideRouter, Routes } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { SwapApiService } from './app/services/swap-api.service';
import { SwapComponent } from './app/swap/swap.component';
import { BridgeComponent } from './app/bridge/bridge.component';
import { SwapAlertComponent } from './app/swap-alert/swap-alert.component';
import { AboutComponent } from './app/about/about.component';
import { DisclaimerComponent } from './app/disclaimer/disclaimer.component';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { SeoUniversalResolver } from './app/seo/seo-universal.resolver';
import { SeoLandingComponent } from './app/seo/seo-landing.component';

import { Buffer } from 'buffer/';
(window as any).global = window;
(window as any).Buffer = Buffer;
import 'zone.js';

// ✅ i18n loader
export function httpLoaderFactory(handler: HttpBackend) {
  return new MultiTranslateHttpLoader(handler, [
    { prefix: '/assets/i18n/', suffix: '.json' },
    { prefix: '/assets/i18n/seo.', suffix: '.json' }
  ]);
}

// ✅ Routes
const routes: Routes = [
  { path: '', component: SwapComponent }, // homepage (sans resolver)
  { path: 'alerts', component: SwapAlertComponent },
  { path: 'a-propos', component: AboutComponent },
  { path: 'bridge', component: BridgeComponent },
  { path: 'disclaimer', component: DisclaimerComponent },
  {
    path: 'bridge-tester',
    loadComponent: () => import('./app/bridge-tester/bridge-tester.component').then(m => m.BridgeTesterComponent)
  },

  { path: ':lang/blog', loadComponent: () => import('./app/blog-list/blog-list.component').then(m => m.BlogListComponent) },
  { path: ':lang/blog/:slug', loadComponent: () => import('./app/blog/blog.component').then(m => m.BlogComponent) },

  // ✅ pages SEO dynamiques (locale + slug) → même component + resolver
  { path: ':locale/:slug', component: SeoLandingComponent, resolve: { seo: SeoUniversalResolver } },

  { path: '**', redirectTo: '' }
];


// 🧩 Patch global pour neutraliser les deeplinks MetaMask automatiques
(() => {
  const origOpen: typeof window.open = window.open;

  // clé de session: on autorise pendant X secondes après une action user
  const ALLOW_KEY = 'st/allowDeeplinkUntil';

  (window as any).open = function (
    url?: string | URL,
    target?: string,
    features?: string
  ): Window | null {
    const s = typeof url === 'string' ? url : String(url || '');

    if (s.startsWith('metamask://wc?')) {
      const allowUntil = Number(sessionStorage.getItem(ALLOW_KEY) || '0');
      const allowed = Number.isFinite(allowUntil) && Date.now() < allowUntil;

      if (!allowed) {
        console.log('[patch] blocked auto MetaMask deeplink:', s);
        return null;
      }
      // autorisé (action user récente)
      console.log('[patch] allowed deeplink (user gesture window):', s);
    }

    return origOpen.call(window, url as any, target, features);
  };

  // petite aide globale pour armer l'autorisation depuis ton code
  (window as any).__allowWcDeeplinkFor = (ms = 10_000) => {
    sessionStorage.setItem(ALLOW_KEY, String(Date.now() + ms));
  };
})();




bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    provideRouter(routes),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpBackend]
      }
    }).providers!
  ]
});
